import { render } from "./PasswordResetPage.vue?vue&type=template&id=f0aa8eb8&scoped=true"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=f0aa8eb8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aa8eb8"]])

export default __exports__